import React from "react"
import { SunIcon, MoonIcon } from "@heroicons/react/20/solid"

type DarkModeToggleProps = {
  className?: string
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ className = "" }) => {
  // The `dark` class on <html> is the source of truth for theme; an inline
  // script in gatsby-ssr.js applies it before first paint.
  const handleClick = () => {
    const isDark = document.documentElement.classList.toggle("dark")
    try {
      localStorage.setItem("darkMode", isDark.toString())
    } catch (e) {}
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Toggle dark mode"
      className={`flex items-center ${className}`}
    >
      <SunIcon className="size-5 ml-2 dark:hidden" />
      <MoonIcon className="size-5 ml-2 hidden dark:block" />
    </button>
  )
}

export default DarkModeToggle
